import { render, staticRenderFns } from "./Paginationn.vue?vue&type=template&id=391bcbc7"
import script from "./Paginationn.vue?vue&type=script&lang=js"
export * from "./Paginationn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports